<template>
<div class="MliveDetails" :class="showAdvSwiper && liveData.adinfolist.length > 0 ? '' : 'MliveDetails_warp'">
    <!-- 董秘APP内嵌提示 -->
    <div class="dmAppTips" v-if="showAppTips">
        <div class="leftTips">
            <img @click="showAppTips = false" :src="require('@/common/images/mobile/close.png')" class="closeIcon" alt="">
            <img v-if="appType === 'appByDM'" :src="require('@/common/images/common/dm_logo.png')" class="logo" alt="">
                  <img v-if="appType === 'appByZJ'" :src="require('@/common/images/common/zj_logo.png')" class="logo" alt="">
            <div class="text">打开{{appType === 'appByDM' ? '董秘' : '鲸融'}}APP，查看更多直播</div>
        </div>
        <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'iOS' && appType === 'appByDM'" :href="'https://www.capwhale.com/ulink/iosdmapp/live/liveDetails/liveDetails?liveid=' + $route.query.liveid" class="rightOpenApp">立即打开</a>
        <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'iOS' && appType === 'appByZJ'" :href="'https://www.capwhale.com/ulink/ioscapwhale/live/live-details?liveid=' + $route.query.liveid" class="rightOpenApp">立即打开</a>
        <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'android' && appType === 'appByDM'" :href="'dmapp://live/liveDetails/liveDetails?liveid=' + $route.query.liveid" class="rightOpenApp">立即打开</a>
        <a @click="handleClickOpenApp" v-if="mobilePhoneType === 'android' && appType === 'appByZJ'" :href="'zjapp://live/live-details?liveid=' + $route.query.liveid" class="rightOpenApp">立即打开</a>
        <div class="wechatOpenApp" v-if="_isWixin() && mobilePhoneType === 'android'">
            <wx-open-launch-app id="launch-btn" appid="wx04d8952d30352373" @error="handlewxOpenApperror"
                :extinfo="appType === 'appByDM' ? 'live/liveDetails/liveDetails?liveid=' + $route.query.liveid : 'zjapp://live/live-details?liveid=' + $route.query.liveid"
                style="position:absolute;top:0;right:0;width: 100%;height: 0.9rem;zIndex: 1000;display: flex;alignItems: center;justifyConent: center">
                <script type="text/wxtag-template">
                    <style>.btn { padding: 14px 50px;color: transparent;text-align: center;background: transparent;border: none;display: block;}</style>
                    <button class="btn">立即打开</button>
                </script>
            </wx-open-launch-app>
        </div>
    </div>
    <!--封面引导-->
    <div v-if="liveData.isopencover" class="guide_cover_pop">
        <van-popup v-model="liveData.isopencover">
            <div class="cover_box">
                <div class="dast_box"></div>
                <img :src="liveData.coverurl" alt="">
                <div class="timer" @click="closeCover">{{timer.num}} 跳过</div>
            </div>
        </van-popup>
    </div>
    <!-- <div class="live_player_box" @click="satrtplay"> -->
    <div class="live_player_box">
        <!-- 直播未开始 -->
        <div v-if="liveData.streamstatus === 0">
            <div v-show="isShowVideo" class="live_cover_box">
                <img class="cover_img" v-lazy="liveData.furl" :alt="liveData.objectname">
                <img v-if="liveData.isopenpreview === 1" @click="playPreviewVideo" class="play_img" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="播放" >
                <!-- <div class="no_start_tag">{{liveData.mobbegintime}}开播</div> -->
            </div>
            <video v-show="!isShowVideo" oncontextmenu="return false;" :src="liveData.previewurl" ref="preview0" id="preview" controls style="object-fit:fill"
                webkit-playsinline="true" playsinline="true" x5-video-player-fullscreen="true" x5-video-player-type="h5-page" x-webkit-airplay="allow"
                x5-video-orientation="portraint" x5-playsinline></video>
        </div>
        <!-- 直播进行中 -->
        <div v-if="liveData.streamstatus === 1">
            <div v-show="isShowVideo" class="live_cover_box">
                <img class="cover_img" v-lazy="liveData.furl" :alt="liveData.objectname">
                <img @click="playLiveingVideo" class="play_img" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="播放" >
                <!-- <div class="liveing_tag">
                    <div class="liveing_tag_left">
                        <img :src="require('@/common/images/mliveimgs/icon_living.png')" alt="">
                        直播中
                    </div>
                    <div class="liveing_tag_right">{{liveData.viewcount}}观看</div>
                </div> -->
            </div>
            <ALive v-show="!isShowVideo" ref="liveing"></ALive>
        </div>
        <!-- 直播暂停 20201103改成和未开始一致 -->
        <!-- <div v-if="liveData.streamstatus === 2">
            <div v-show="isShowVideo" class="live_cover_box">
                <img class="cover_img" v-lazy="liveData.furl" :alt="liveData.objectname">
                <img v-if="liveData.isossplay === 1" class="play_img" @click="livePauseClick" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="播放" >
                <div class="liveing_tag">
                    <div class="liveing_tag_left">
                        <img :src="require('@/common/images/mliveimgs/icon_lived.png')" alt="">
                        暂停
                    </div>
                    <div class="liveing_tag_right">{{liveData.viewcount}}观看</div>
                </div>
            </div>
            <ALive v-show="!isShowVideo" ref="livepause"></ALive>
        </div> -->
        <div v-if="liveData.streamstatus === 2">
            <div v-show="isShowVideo" class="live_cover_box">
                <img class="cover_img" v-lazy="liveData.furl" :alt="liveData.objectname">
                <img v-if="liveData.isopenpreview === 1" @click="playPreviewVideo" class="play_img" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="播放" >
                <!-- <div class="liveing_tag">
                    <div class="liveing_tag_left">
                        <img :src="require('@/common/images/mliveimgs/icon_lived.png')" alt="">
                        暂停
                    </div>
                    <div class="liveing_tag_right">{{liveData.viewcount}}观看</div>
                </div> -->
            </div>
            <video v-show="!isShowVideo && liveData.previewurl" oncontextmenu="return false;" :src="liveData.previewurl" ref="preview0" id="preview" controls style="object-fit:fill"
                webkit-playsinline="true" playsinline="true" x5-video-player-fullscreen="true" x5-video-player-type="h5-page" x-webkit-airplay="allow"
                x5-video-orientation="portraint" x5-playsinline></video>
        </div>
        <!-- 直播结束 -->
        <div v-if="liveData.streamstatus === 10">
            <div v-show="isShowVideo" class="live_cover_box">
                <img class="cover_img" v-lazy="liveData.furl" :alt="liveData.objectname">
                <img v-if="liveData.isossplay === 1" class="play_img" @click="liveEndClick" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="播放" >
                <!-- <div class="liveing_tag">
                    <div class="liveing_tag_left">
                        <img :src="require('@/common/images/mliveimgs/icon_lived.png')" alt="">
                        回放
                    </div>
                    <div class="liveing_tag_right">{{liveData.viewcount}}观看</div>
                </div> -->
            </div>
            <ALive v-show="!isShowVideo" ref="liveend"></ALive>
        </div>
    </div>
    <div v-if="showAdvSwiper && liveData.adinfolist.length > 0" class="adv_swiper_box">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in liveData.adinfolist" :key="index">
                <!-- {{index}} -->
                <img class="adv_img" :src="item.logourl" alt="" @click="clickLiveAD(item.redirecturl)">
            </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator"></div>
            </template>
        </van-swipe>
        <!-- <div class="adv_close_box">
            <img @click="showAdvSwiper = false" :src="require('@/common/images/mliveimgs/icon_close_adv.png')" alt="">
        </div> -->
        <div class="count_down">
            {{countDownValue}}s
        </div>
    </div>
    <div class="vliveDetail" v-if="liveData.contentlist.length > 0" @scroll="vliveDetailScroll">
        <div class="live_msg_box" id="liveMsg">
            <div class="inner_box">
                <p class="live_title">{{liveData.objectname}}</p>
                <p class="desp" v-if="liveData.description">{{liveData.description}}</p>
                <!-- 直播未开始 -->
                <div class="have_not_started" v-if="liveData.streamstatus === 0">
                    {{liveData.mobbegintime}} 开播
                </div>
                <!-- 直播进行中 -->
                <div class="underway" v-if="liveData.streamstatus === 1">
                    <span class="viewcount">{{liveData.viewcount}}次观看</span><span class="line">|</span>正在直播
                </div>
                <!-- 直播暂停中 -->
                <div class="suspend" v-if="liveData.streamstatus === 2">
                    <span class="viewcount">{{liveData.viewcount}}次观看</span><span class="line">|</span>已暂停
                </div>
                <!-- 直播结束 -->
                <div class="finished" v-if="liveData.streamstatus === 10">
                    <div v-if="liveData.isossplay !== 1"><span class="viewcount">{{liveData.viewcount}}次观看</span><span class="line">|</span>已结束</div>
                    <div class="isossplay" v-else><span class="viewcount">{{liveData.viewcount}}次观看</span><span class="line">|</span>回放中</div>
                </div>
            </div>
        </div>
        <!--直播内容-->
        <div class="content">
			<van-tabs sticky @click="tabClick" :ellipsis="false" v-model="actived" swipeable :class="{'noFixed': true, 'isFixed': isFixed}" animated line-height="2" :line-width="tabsLineWidth" ref="vliveTabs" color="#409EFF" title-inactive-color="#333" title-active-color="#409EFF">
                <van-tab v-for="(item, index) in liveData.contentlist" :key="index" :disabled="item.columntype === 99">
                    <template #title>
                       <div @click="clickLinkurl(item)">{{item.columnname}}</div>
                    </template>
                    <div class="column_box">
                        <div v-if="item.columntype === 1" class="column_div type1">
                            <div v-if="item.content === ''" class="no_data_box">
                                <img :src="require('@/common/images/mliveimgs/no_data.png')" alt="">
                                <span>当前暂无内容</span>
                            </div>
                            <div v-else v-html="item.content"></div>
                        </div>
                        <div v-if="item.columntype === 2" class="column_div type2">
                            <div v-if="item.videolist.length === 0" class="no_data_box">
                                <img :src="require('@/common/images/mliveimgs/no_data.png')" alt="">
                                <span>当前暂无内容</span>
                            </div>
                            <div v-else class="video_box">
                                <div v-for="(video, i) in item.videolist" :key="i" @click="playVideo(video.fileurl)">
                                    <img class="video_img" v-lazy="video.coveratturl" alt="">
                                    <img class="play_icon" :src="require('@/common/images/mliveimgs/icon_play.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div v-if="item.columntype === 3" class="column_div type3">
                            <div v-if="item.imagelist.length === 0" class="no_data_box">
                                <img :src="require('@/common/images/mliveimgs/no_data.png')" alt="">
                                <span>当前暂无内容</span>
                            </div>
                            <div v-else class="imgs_box">
                                <img @click="previewImageClick(item.imagelist, i)" v-for="(img, i) in item.imagelist" :key="i" v-lazy="img.fileurl" alt="">
                            </div>
                        </div>
                        <div v-if="item.columntype === 5" class="column_div type5" :class="discussList.length > 10 ? 'height100vh' : ''">
                        <!-- <div v-if="item.columntype === 5" class="column_div type5"> -->
                            <div v-if="discussList.length === 0" class="no_data_box">
                                <img :src="require('@/common/images/mliveimgs/no_data.png')" alt="">
                                <span>当前暂无评论</span>
                            </div>
                            <div v-else class="discuss_warp">
                                <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
                                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" >
                                        <div class="discuss_item_box" v-show="item.ispraise === 0" v-for="(item, index) in discussList" :key="index">
                                            <img v-if="item.ispraise === 0" :src="item.customeratturl" alt="">
                                            <div v-if="item.ispraise === 0" class="info_box">
                                                <p class="name_text" :class=" item.isowncomment === 1 ? 'is_me' : ''">{{item.customername}}</p>
                                                <p class="msg_text">{{item.content}}</p>
                                            </div>
                                        </div>
                                    </van-list>
                                <!-- </van-pull-refresh> -->
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <!-- <div class="label_box" id="labelBox">标签</div> -->
        </div>
        <!-- 购买按钮 -->
        <div class="buy_btn_box" v-if="liveData.feetype === 2 && !liveData.isbuy && (liveData.streamstatus !== 10 || liveData.isossplay)">
            <van-button @click="clickBuy">购买 ￥{{liveData.saleprice}} <span class="uprice" v-if="liveData.uprice > liveData.saleprice">￥{{liveData.uprice}}</span></van-button>
        </div>
    </div>

    <div class="videoShow_pop">
        <van-popup v-model="videoShow" @close="closeVideoPop">
            <video :src="videoUrl" ref="vliveVideo" oncontextmenu="return false;" style="object-fit:fill" controls
                   webkit-playsinline="true" playsinline="true" x5-video-player-fullscreen="true" x5-video-player-type="h5" x-webkit-airplay="allow"
                   x5-video-orientation="portraint" x5-playsinline></video>
        </van-popup>
    </div>
    <div v-show="showBottom" class="bottom_warp">
        <div v-if="user.isLogin" class="logged">
            <van-field v-model="commentMsg" placeholder="快来讨论一下吧～" />
            <van-button @click="sendCommentMsg" type="info">发送</van-button>
        </div>
        <div v-else class="not_login">
            <van-button @click="toLoginPage" type="info">快快登录参与评论吧～</van-button>
        </div>
    </div>
    <div class="serviceqrurl_pop">
        <van-popup v-model="serviceQrUrlPop" position="center">
            <img :src="liveData.mpqratturl" alt="">
            <p class="tip_text">长按保存二维码</p>
        </van-popup>
    </div>
    <!-- 输入密码弹窗 -->
    <div class="input_password_pop">
        <van-popup v-model="inputPasswordPop" position="center">
            <p class="title">该直播需要密码</p>
            <div class="input_box">
                <van-field v-model="livepass" placeholder="请输入正确密码"></van-field>
            </div>
            <div class="btn_box">
                <div class="cancel" @click="inputPasswordPop = false">取消</div>
                <div class="affirm" @click="checkLiveEventPassword">确定</div>
            </div>
        </van-popup>
    </div>
    <div class="shortcut_box">
        <div @click="jumpClick('MLiveIndex')">
            <img :src="require('@/common/images/mliveimgs/icon1.png')" alt="">
            <span>首页</span>
        </div>
        <div @click="toJumpPage">
            <img :src="require('@/common/images/mliveimgs/icon2.png')" alt="">
            <span>海报</span>
        </div>
        <div v-if="liveData.mpqratturl !== ''" @click="serviceQrUrlPop = true">
            <img :src="require('@/common/images/mliveimgs/icon3.png')" alt="">
            <span>公众号</span>
        </div>
        <div v-if="liveData.isopenenroll === 1" @click="enrollClick">
            <img :src="require('@/common/images/mliveimgs/icon4.png')" alt="">
            <span>报名</span>
        </div>
    </div>
</div>
</template>

<script>
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import {getAliveProductDetail, getLiveComment, getLiveNewCommentList, addCommentInfo, getVliveStatus, checkLiveEventPassword} from 'api/mLiveApi'
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
import $ from 'jquery'
import ALive from './components/alive'
import { getAssignKeyLocationSearch, setCookie, examineMobilePhoneType } from 'common/js/tools.js'
import {getCustomerInfoByApp} from 'api/api'
export default {
    metaInfo() {
        return {
            meta: [
                {
                    name: "keywords",
                    content: this.keywords
                },                
                {
                    name: "description",
                    content: this.description
                }
            ]
        }
    },
    name: 'MliveDetails',
    data() {
        return {
            isFixed: false,
            keywords: '',
            description: '',
            isShowVideo: true, // 显示直播封面 还是 直播视频
            showBottom: false, // 是否显示底部评论
            commentMsg: '', // 评论消息
            videoShow: false,  // 是否显示视频弹窗
            videoUrl: '',  // 视频url地址
            // testImgUrl: 'http://innertest.img.capwhale.com/kmc/content/20200526/c43d5e02345a4e2eba642a5d0d4340fd',
            actived: 0,
            timer: {
                countdown: false,
                num: 3
            },
            imgsList: [],
            showAdvSwiper: true,
            liveData: {
                kmctype: 3, // 内容类型
                objectid: '',
                objectname: '', // 内容名称
                feetype: 0, // 是否收费 1免费 2收费
                furl: '', // 内容logourl
                flvurl: '', // 播流地址
                viewcount: '', // 浏览量
                datetime: '', // 创建时间
                begintime: '', // 开始时间
                uprice: '', // 划线价格
                saleprice: '', // 销售价格，免费的时候不展示，如果划线价格为0，只展示销售价格，限时促销的时候该价格为促销价格
                mkprice: '', // 促销后价格
                ispraise: 0, // 是否已点赞 0未点赞 1已点赞
                isfavorite: 0, // 是否已收藏 0未收藏 1已收藏
                isbuy: 0, // 是否已购买，0未购买 1已购买 如果是免费，可以直接赋值已购买，其他都不用判断了
                mktype: 0, // 促销类型，0无 1限免: 2拼团: 5助力: 6分享解锁
                ismkorder: 0, // 是否参与促销 0未参与 1已参与
                mkorderid: '', // 参与促销的订单id
                isneedmkinfo: 0, // 是否可以参与促销 0不能参与 1可以参与
                assetmkinfo: '', // 促销配置详情
                description: '', // 描述信息
                streamstatus: 0, // 直播流状态(0未开始 1推流中 2暂停推流 10结束直播)
                rtmpurl: '', // 流地址
                contentthemecolor: '', // 内容模块主题色
                isopencover: false, // 是否开启引导封面 0否 1开启
                coverurl: '', // 引导封面url
                isopenpreview: true, // 是否开启预告片 0否 1开启
                previewurl: '', // 预告片url
                isopenmp: 0, // 是否开启关注公众号 0否 1开启
                openmpname: '', // 公众号名称
                mplogoatturl: '', // 公众号logo
                mpqratturl: '', // 公众号的二维码url
                isopenenroll: 0, // 是否开启报名 0否 1开启
                enrolliconurl: '', // 报名按钮图标url
                enrollurl: '', // 报名跳转链接
                sharesubject: '', // 微信分享标题
                sharedesc: '', // 微信分享简介
                sharelogourl: '', // 微信分享图标URL
                isopenad: 0, // 是否开启广告 0否 1开启
                adinfolist: [], // 广告
                isossplay: 1, // 是否支持回放
                ossurl: '', // 回放地址
                ossurltype:1,//地址类型
                contentlist: [ // 模块列表
                    {
                        columnname: '', // 模块名称
                        columntype: '', // 模块类型(1图文 2视频 3相册)
                        content: '', // 图文内容
                        videolist: [],
                        imagelist: []
                    }
                ]
            },
            discussList: [],
            maxId: 0,
            initTimer: {},
            initTimer2: {},

            serviceQrUrlPop: false, // 公众号二维码弹窗

            isLoading: false, // 下拉刷新

            loading: false,  // 上拉加载
            finished: false,  // 上拉加载
            countDownValue: 6,
            tabsLineWidth: 0,
            tabs__line: null,
            inputPasswordPop: false,
            livepass: '',
            vanSticky: null,
            liveMsg: null,
            tabbarOffsetTop: 0,
            showAppTips: false,
            appType: '',
            mobilePhoneType: examineMobilePhoneType()
        }
    },
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'VideoLiveing',
                query: {'innerid': this.$route.query.liveid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
            })
        }
        if (getAssignKeyLocationSearch('appflag', ['appByDM'])) {
            this.showAppTips = true
            this.appType = getAssignKeyLocationSearch('appflag')
        } else {
            this.showAppTips = false
        }
        if (getAssignKeyLocationSearch('apptoken') && getAssignKeyLocationSearch('appflag', ['appByDM'])) {
            this.getCustomerInfoByApp()
        }
    },
    mounted() {
        this.findAliveProductDetail()
        let _this = this
        this.initTimer = setInterval(() => {
            if (this.liveData.isopencomment === 1 && this.showBottom) {
                _this.findNewLiveCommentList()
            }
        }, 1000 * 20)
    },
    methods: {
        getCustomerInfoByApp() {
            this.setLoading(true)
            getCustomerInfoByApp({
                data: {},
                success: data => {
                    let user = {
                        innerid: data.data.innerid ? data.data.innerid : '',
                        isperfect: data.data.isperfect ? data.data.isperfect : '',
                        loginToken: data.data.logintoken ? data.data.logintoken : '',
                        loginname: data.data.loginname ? data.data.loginname : '',
                        logourl: data.data.logourl ? data.data.logourl : '',
                        mobile: data.data.mobile ? data.data.mobile : '',
                        name: data.data.name ? data.data.name : '',
                        nickname: data.data.nickname ? data.data.nickname : '',
                        isLogin: true,
                        zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                    }
                    this.setUser(user)
                    sessionStorage.setItem('user', JSON.stringify(user))
                    setCookie('token', user.loginToken, 7)
                },
                error: data => {
                    this.setLoading(false)
                    // this.$toast.fail(data.msg)
                }
            })
        },
        vliveDetailScroll(e) {
            if (e.target.scrollTop > this.liveMsg.clientHeight) { // 使用绝对定位
                this.isFixed = true
                this.vanSticky.style.top = this.liveMsg.offsetTop + 'px'
            } else {
                this.isFixed = false
                this.vanSticky.style.top = this.liveMsg.offsetTop + this.liveMsg.clientHeight + 'px'
            }
        },
        // 确认提交密码
        checkLiveEventPassword() {
            if (this.livepass) {
                this.setLoading(true)
                checkLiveEventPassword({
                    data: {liveid: this.liveData.objectid, livepass: this.livepass, channelid: this.$route.query.chid ? this.$route.query.chid : ''},
                    success: () => {
                        this.setLoading(false)
                        location.reload()
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$toast.fail(res.msg)
                    }
                })
            } else {
                this.$toast.fail('请输入密码!')
            }
        },
        // 打开输入密码弹窗
        openPassPop() {
            this.inputPasswordPop = true
        },
        clickBuy() {
            if (this.user.isLogin) {
                this.$router.push({
                    name: 'MConfirmOrder',
                    query: {
                        liveid: this.liveData.objectid,
                        kmctype: 3,
                        chid: this.$route.query.chid ? this.$route.query.chid : ''
                    }
                })
            } else {
                this.$router.push({name: 'MLogin'})
            }
        },
        clickLinkurl(item) {
            // console.log(this.liveData.contentlist[index])
            if (item.columntype === 99) {
                window.open(item.linkurl)
            } 
            // else {
            //     this.tabs__line.innerText = this.liveData.contentlist[index].columnname
            // }
        },
        // 报名
        enrollClick() {
            window.open(this.liveData.enrollurl)
        },
        //广告点击
        clickLiveAD(url){
            if(url!=""){
                window.open(url)
            }
        },
        // 海报
        toJumpPage() {
            this.$router.push({name: 'MLivePoster', query: {'liveid': this.$route.query.liveid}})
        },
        jumpClick(val) {
            this.$router.push({name: val})
        },
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        // 下拉刷新
        onRefresh() {
            this.findNewLiveCommentList()
            this.isLoading = false
            // setTimeout(() => {
            //     Toast('刷新成功');
            //     this.isLoading = false;
            //     this.count++;
            // }, 1000);
        },
        // 上拉加载
        onLoad() {
            // this.setLoading(true)
            var params = {
                // kmcinnerid: 'lLhX9plmjcjTdym6',
                kmcinnerid: this.$route.query.liveid,
                minmsgid: this.discussList[this.discussList.length-1].comid,
                pageSize: 10,
                isopencomment: 1
            }
            getLiveComment({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    this.discussList = this.discussList.concat(data.data.commentinfo)
                    this.loading = false
                    // this.finished = true
                    if (data.data.commentinfo.length === 0) {
                        this.finished = true
                    } 
                    // setTimeout(() => {
                    //     if (data.data.commentinfo.length === 0) {
                    //         console.log('aaaaaaaaaa')
                    //         this.finished = true
                    //     } else {
                    //         console.log('bbbbbb')
                    //         this.finished = false
                    //     }
                    // }, 1000)
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 获取直播状态
        findVliveStatus() {
            // this.setLoading(true)
            var params = {
                // objectid: 'lLhX9plmjcjTdym6'
                objectid: this.$route.query.liveid
            }
            getVliveStatus({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    if (data.data.streamstatus === this.liveData.streamstatus) {
                        // console.log('返回')
                        return
                    } else {
                        // console.log('处理')
                        this.liveData.streamstatus = data.data.streamstatus
                        if (this.liveData.isbuy) {
                            // 直播中
                            if (data.data.streamstatus === 1) {
                                this.isShowVideo = false
                                this.$refs.liveing.leveingPlay(data.data.flvurl)
                            }
                            // 直播暂停 20201103改成和未开始一致
                            if (data.data.streamstatus === 2) {
                                if (data.data.isossplay === 1 && data.data.ossurl) {
                                    this.isShowVideo = false
                                    this.$refs.livepause.leveingPlay(data.data.ossurl)
                                } else {
                                    this.isShowVideo = true
                                }
                            }
                            // 直播结束
                            if (data.data.streamstatus === 10) {
                                if (this.initTimer2) {
                                    clearInterval(this.initTimer2)
                                }
                                if (data.data.isossplay === 1) {
                                    this.isShowVideo = false
                                    if(data.data.ossurltype==1){
                                        this.$refs.liveend.leveingPlay(data.data.ossurl)
                                    }
                                    else{
                                        this.$refs.liveend.playpreview(data.data.ossurl)
                                    }
                                } else {
                                    this.isShowVideo = true
                                }
                            }
                        }
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 直播未开始播放预告视频
        playPreviewVideo() {
            this.isShowVideo = false
            this.$refs.preview0.play()
        },
        // 直播进行中播放直播
        playLiveingVideo() {
            if (this.liveData.isbuy === 1) {
                this.isShowVideo = false
                this.$refs.liveing.leveingPlay(this.liveData.flvurl)
            } else {
                if (!this.user.isLogin) {
                    this.$router.push({name: 'MLogin'})
                } else {
                    if (this.liveData.feetype === 2) {
                        this.clickBuy()
                    } else if (this.liveData.feetype === 3) {
                        this.openPassPop()
                    }
                }
            }
        },
        // 直播暂停点击播放
        livePauseClick() {
            this.isShowVideo = false
            this.$refs.livepause.leveingPlay(this.liveData.ossurl)
        },
        // 直播结束
        liveEndClick() {
            if (this.liveData.isbuy === 1) {
                this.isShowVideo = false
                if(this.liveData.ossurltype==1){
                    this.$refs.liveend.leveingPlay(this.liveData.ossurl)
                }
                else{
                    this.$refs.liveend.playpreview(this.liveData.ossurl)
                }
            } else {
                if (!this.user.isLogin) {
                    this.$router.push({name: 'MLogin'})
                } else {
                    if (this.liveData.feetype === 2) {
                        this.clickBuy()
                    } else if (this.liveData.feetype === 3) {
                        this.openPassPop()
                    }
                }
            }
        },
        // 播放视频
        satrtplay() {
            // this.videohead = false
            // this.$refs.videoPlayer.player.play()
            if (this.liveData.streamstatus === 1) {
                // 直播中
                this.$refs.video1.leveingPlay(this.liveData.flvurl)
            } else if (this.liveData.streamstatus === 2 || this.liveData.streamstatus === 10) {
                // 直播暂停或者结束
                this.$refs.video1.leveingPlay(this.liveData.ossurl)
            }
        },
        // 播放预告片
        previewPlay(flvurl) {
            // this.videohead = false
            this.$refs.video2.playpreview(flvurl)
        },
        // 点击tab进行判断，评论栏目显示底部评论input
        // tabClick(name, title) {
        tabClick(name) {
            if (this.liveData.contentlist[name].columntype !== 99) {
                this.tabs__line.innerText = this.liveData.contentlist[name].columnname
            }
            // console.log(title)
            if (this.liveData.contentlist[name].columntype === 5) {
                // 显示底部评论
                this.showBottom = true
                return
            } else {
                this.showBottom = false
            }
            
        },
        // 获取视频直播评论列表
        findLiveCommentList() {
            this.setLoading(true)
            var params = {
                kmcinnerid: this.$route.query.liveid,
                minmsgid: -1,
                pageSize: 10,
                isopencomment: 1
            }
            getLiveComment({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.discussList = data.data.commentinfo
                    if (this.discussList.length > 0) {
                        this.maxId = this.discussList[0].comid
                    } else {
                        this.maxId = 0
                    }
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 获取最新评论
        findNewLiveCommentList() {
            // this.setLoading(true)
            var params = {
                kmcinnerid: this.$route.query.liveid,
                maxmsgid: this.maxId,
                isopencomment: '1'
            }
            // if (this.discussList.length > 0) {
            //     params.maxmsgid = this.discussList[0].comid
            // }
            getLiveNewCommentList({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    this.discussList = data.data.commentinfo.concat(this.discussList)
                    if (data.data.commentinfo.length > 0) {
                        // this.maxId = data.data.commentinfo[data.data.commentinfo.length-1].comid
                        this.maxId = data.data.commentinfo[0].comid
                    }
                    // $('html').scrollTop(0)
                    $('.height100vh').scrollTop(0)
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 获取直播详情相关数据
        findAliveProductDetail() {
            this.setLoading(true)
            var params = {
                objectid: this.$route.query.liveid,
                channelid: this.$route.query.chid ? this.$route.query.chid : ''
            }
            getAliveProductDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    // data.data.streamstatus = 10
                    // data.data.isopenpreview = 1
                    // data.data.isossplay = 1
                    this.liveData = data.data
                    if (this.liveData.streamstatus !== 10) {
                        this.initTimer2 = setInterval(() => {
                            this.findVliveStatus()
                        }, 1000 * 30)
                    }
                    // this.liveData.isopencover = this.liveData.isopencover === 1 ? true : false
                    if (this.liveData.isopencover === 1) {
                        this.liveData.isopencover = true
                    } else {
                        this.liveData.isopencover = false
                    }
                    if (this.liveData.adinfolist.length) {
                        this.tabbarOffsetTop = '5.3rem'
                    } else {
                        this.tabbarOffsetTop = '4.2rem'
                    }
                    // document.title=this.liveData.objectname
                    document.title=this.liveData.objectname + '-' + '精品直播'
                    this.keywords = this.liveData.objectname + ',' + this.liveData.tags + ',鲸融网,精品直播'
                    this.description = this.liveData.description
                    if (this.liveData.adinfolist.length) {
                        let timer = setInterval(() => {
                            if (this.countDownValue > 0) {
                                this.countDownValue--
                                if (this.countDownValue === 0) {
                                    this.showAdvSwiper = false
                                }
                            } else {
                                clearInterval(timer)
                            }
                        }, 1000)
                    }
                    this.$nextTick(() => {
                        this.tabs__line = document.getElementsByClassName('van-tabs__line')[0]
                        let van_tab = document.getElementsByClassName('van-tab')[0]
                        this.tabs__line.style.width = van_tab.clientWidth + 'px'
                        this.tabs__line.style.backgroundImage = `url(${require('@/common/images/mliveimgs/tab_bg.png')})`
                        this.tabs__line.innerText = this.liveData.contentlist[0].columnname
                        this.liveMsg = document.getElementById('liveMsg')
                        this.vanSticky = document.getElementsByClassName('van-sticky')[0]
                        // let vliveDetail = document.getElementsByClassName('vliveDetail')[0]
                        this.vanSticky.style.top = this.liveMsg.offsetTop + this.liveMsg.clientHeight + 'px'
                        // window.onscroll = this.vliveDetailScroll
                        // vliveDetail.style.paddingTop = liveMsg.offsetTop + liveMsg.clientHeight + 'px'
                        // console.log(liveMsg.offsetTop, liveMsg.clientHeight, vanSticky)
                    })
                    // 如果设置了引导封面，开始引导封面倒计时
                    this.countdown()
                    if (this._isWixin()) {
                        // Toast('微信分享')
                        // let link = `http://ke.capwhale.com/courseView?cid=${this.$route.query.cid}`
                        let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + this.$route.query.liveid + '&chid=' + (this.$route.query.chid ? this.$route.query.chid : '')
                        getWXSDKSetting({
                            title: this.liveData.sharesubject === '' ? this.liveData.objectname : this.liveData.sharesubject,
                            desc: this.liveData.sharedesc === '' ? this.liveData.description : this.liveData.sharedesc,
                            link: link,
                            imgUrl: this.liveData.sharelogourl === '' ? this.liveData.furl : this.liveData.sharelogourl,
                        })
                    }
                    // 如果栏目列表里面有评论栏目  调取评论接口
                    for (let i = 0; i < this.liveData.contentlist.length; i++) {
                        if (this.liveData.contentlist[i].columntype === 5) {
                            // console.log('获取评论')
                            this.findLiveCommentList()
                            return
                        }
                    }
                    // if (this.liveData.contentlist.length) {
                    //     this.$nextTick(() => {
                    //         let 
                    //     })
                    // }
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 图片预览
        previewImageClick(previewImageList, index) {
            let tmp = []
            previewImageList.forEach(obj => {
                tmp.push(obj.fileurl)
            })
            this.$imagePreview({
                images: tmp,
                startPosition: index,
                maxZoom: 10,
                minZoom: 1/5
            })
        },
        // 视频预览
        playVideo(videoUrl) {
            this.videoUrl = videoUrl
            this.videoShow = true
            this.$nextTick(() => {
                this.$refs.vliveVideo.play()
            })
        },
        closeVideoPop() {
            this.videoUrl = ''
            this.videoShow = false
        },
        // 关闭引导封面
        closeCover() {
            this.liveData.isopencover = false
        },
        // 关闭引导封面倒计时
        countdown () {
            let _this = this
            let timer = setInterval(() => {
                _this.timer.num--
            }, 1000)
            setTimeout(() => {
                clearInterval(timer)
                _this.liveData.isopencover = false
            }, 3000)
        },
        // 发送评论
        sendCommentMsg() {
            // this.setLoading(true)
            var params = {
                // kmcinnerid: 'lLhX9plmjcjTdym6',
                kmcinnerid: this.$route.query.liveid,
                content: this.commentMsg
            }
            addCommentInfo({
                data: Object.assign({}, params),
                success: () => {
                    // this.setLoading(false)
                    // console.log(data.data)
                    this.commentMsg = ''
                    Toast('评论成功')
                    $('.height100vh').scrollTop(0)
                    this.findNewLiveCommentList()
                },
                error: data => {
                    // console.log('error：', data)
                    // this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 跳转到登录页面
        toLoginPage() {
            this.$router.push({name: 'MLogin'})
        },
        handlewxOpenApperror(e) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + this.$route.query.liveid + '&appflag=' + this.appType
            if (e.detail.errMsg === 'launch:fail') { // 未安装APP
                if (this.appType === 'appByDM') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                    }
                } else if (this.appType === 'appByZJ') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                    }
                }
            } else if (e.detail.errMsg === 'launch:fail_check fail') { // appid未绑定未关联到微信
                if (this.appType === 'appByDM') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                    }
                } else if (this.appType === 'appByZJ') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                    }
                }
            }
        },
        handleClickOpenApp() {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + this.$route.query.liveid + '&appflag=' + this.appType
            setTimeout(() => {
                if (this.appType === 'appByDM') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                    }
                } else if (this.appType === 'appByZJ') {
                    if (this.mobilePhoneType === 'iOS') {
                        window.location.href = 'https://apps.apple.com/cn/app/id1570226796'
                    } else {
                        window.location.href = 'https://m.capwhale.com/mapp?topage=' + encodeURIComponent(link)
                    }
                }
            }, 2000)
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    },
    filters: {},
    watch: {
        'showAdvSwiper': {
            handler(newV) {
                if (!newV) {
                    this.$nextTick(() => {
                        // this.liveMsg = document.getElementById('liveMsg')
                        this.vanSticky.style.top = this.liveMsg.offsetTop + this.liveMsg.clientHeight + 'px'
                        this.tabbarOffsetTop = '4.2rem'
                    })
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {ALive},
    destroyed() {
        clearInterval(this.initTimer)
        clearInterval(this.initTimer2)
        // if (this.liveData.isopencomment === 1) {
        // }
    }
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/index";
.MliveDetails {
    background: #fff;
    height: 100vh;
    .dmAppTips {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.9rem;
        background: #333;
        z-index: 100000;
        display: flex;
        .leftTips {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 0 0.2rem;
            .closeIcon {
                width: 0.25rem;
                height: 0.25rem;
                margin-right: 0.3rem;
            }
            .logo {
                width: 0.6rem;
                height: 0.6rem;
            }
            .text {
                flex: 1;
                color: #fff;
                font-size: 0.28rem;
                text-align: center;
            }
        }
        .wechatOpenApp {
            position: absolute;
            width: 25%;
            height: 100%;
            right: 0;
            top: 0;
            overflow: hidden;
            z-index: 10000;
            background: transparent;
        }
        .rightOpenApp {
            width: 25%;
            text-align: center;
            height: 100%;
            background: #F63515;
            color: #fff;
            line-height: 0.9rem;
            font-size: 0.28rem;
        }
    }
    .guide_cover_pop {
        .cover_box{
            position: relative;
            width: 100vw;
            height: 100vh;
            img{
                width: 100%;
                height: 100%;
            }
            .timer{
                width: 1.28rem;
                height: 0.58rem;
                display: flex;
                align-items: center;
                justify-content: center;

                position: absolute;
                top: 0.44rem;
                right: 0.3rem;
                background:rgba(0,0,0,0.5);
                border-radius: 0.3rem;
                z-index: 20001;
                color: rgb(255, 255, 255);
                font-size: 0.28rem;
                // padding: 0.1rem 0.24rem;
                opacity: 0.8;
            }
            .dast_box {
                background:rgba(0,0,0,0.4);
                position: absolute;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
            }
        }
    }
    .live_player_box {
        background-color: rgb(150, 148, 148);
        // background-color: rgba(0,0,0,1);
        height: 4.22rem;
        width: 100vw;
        position: fixed;
        top:0;
        z-index: 10;
        .live_cover_box {
            position: relative;
            .cover_img {
                min-height: 4.22rem;
                height: 4.22rem;
                min-width: 100vw;
                width: 100vw;
            }
            .play_img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 1.5rem;
                height: 1.5rem;
            }
            .no_start_tag {
                position: absolute;
                right: 0;
                top: 0.32rem;
                line-height: 0.4rem;
                font-size: 0.24rem;
                background-color: #F56C6C;
                color: #fff;
                padding: 0 0.12rem;
                border-radius: 0.2rem 0 0 0.2rem;
            }
            .liveing_tag {
                position: absolute;
                right: 0.2rem;
                top: 0.32rem;
                line-height: 0.4rem;
                font-size: 0.24rem;
                color: #fff;
                border-radius: 0.2rem;
                overflow: hidden;
                display: flex;
                &>div {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .liveing_tag_left {
                    background-color: #F56C6C;
                    width: 1.2rem;
                    img {
                        width: 0.2rem;
                        height: 0.2rem;
                        margin-right: 0.06rem;
                    }
                }
                .liveing_tag_right {
                    background-color: #ccc;
                    width: 1.2rem;
                }
            }
        }
        video{
            min-height: 4.22rem;
            height: 4.22rem;
            min-width: 100vw;
            width: 100vw;
        }
    }
    .adv_swiper_box {
        position: relative;
        position: fixed;
        top: 4.22rem;
        z-index: 10;
        .my-swipe {
            width: 100vw;
            height: 1.1rem;
            .van-swipe-item {
                width: 100vw;
                height: 1.1rem;
                .adv_img {
                    width: 100vw;
                    height: 1.1rem;
                }
            }
        }
        .adv_close_box {
            position: fixed;
            top: 4.34rem;
            right: 0.22rem;
            &>img {
                width: 0.4rem;
                height: 0.4rem;
            }
        }
        .count_down {
            position: fixed;
            top: 4.34rem;
            right: 0.22rem;
            width: 0.6rem;
            height: 0.32rem;
            border-radius: 0.16rem;
            width: 0.6rem;
            height: 0.32rem;
            text-align: center;
            line-height: 0.32rem;
            font-size: 0.18rem;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);
        }
    }
    .live_msg_box {
        // position: fixed;
        // height: 2.98rem;
        width: 100%;
        top: 5.33rem;
        box-sizing: border-box;
        z-index: 1005;
        background: #F7F7F7;
        padding-bottom: 0.2rem;
        .inner_box {
            padding: 0.32rem;
            background: #fff;
        }
        .live_title {
            font-size: 0.32rem;
            font-weight: bold;
            margin-bottom: 0.2rem;
            line-height: 0.45rem;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
        }
        .desp {
            font-size: 0.28rem;
            color: #999999;
            line-height: 0.36rem;
            margin-bottom: 0.2rem;
            // text-overflow: -o-ellipsis-lastline;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 3;
            // line-clamp: 3;
            // -webkit-box-orient: vertical;
            // height: 1.08rem;
        }
        .have_not_started {
            font-size: 0.28rem;
            color: #EC5E69;
            line-height: 0.4rem;
        }
        .underway {
            font-size: 0.28rem;
            color: #63CB89;
            .viewcount {
                color: #999999;
            }
            .line {
                margin: 0 0.2rem;
                color: #999999;
            }
        }
        .suspend, .finished {
            font-size: 0.28rem;
            color: #999999;
            .line {
                margin: 0 0.2rem;
            }
        }
        .finished {
            .isossplay {
                color: #F1C205;
                .viewcount, .line {
                    color: #999999;
                }
            }
        }
    }
    .vliveDetail{
        overflow: scroll;
        padding-top: 5.3rem;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        // position: fixed;
        // top: 5.32rem;
        // width: 100vw;
        // height: calc(100vh - 5.32rem);
        .content{
            // background: $bgcolor-white;
            // font-size: $mfont-28;
            min-height: calc(100% - 1.16rem);
            // background-color: rgb(206, 187, 187);
            // position: relative;
            .van-tabs {
                position: inherit;
            }
            .van-tabs__line {
                top: 0;
                height: 0.8rem !important;
                border: none !important;
                background-color: none !important;
                // background-image: url('../../../../common/images/mliveimgs/tab_bg.png');
                background-size: 100% 100%;
                text-align: center;
                line-height: 0.8rem;
                color: #409EFF;
                // bottom: 0.4rem;
                font-size: 0.28rem;
            }
            .noFixed{
                .van-sticky{
                    width: 100%;
                    position: absolute;
                    top: 8.5rem;
                    z-index: 1000;
                }
            }
            .isFixed{
                .van-sticky{
                    width: 100%;
                    position: fixed;
                    // top: 8.5rem;
                    z-index: 1000;
                }
            }
            .van-tabs__wrap{
                height: 0.8rem;
                .van-tabs__nav--complete {
                    background: #D4E6FF;
                    padding-right: 0;
                    padding-left: 0;
                    border: none;
                }
            }
            .van-tab{
                @include flexBox(center);
                background: #D4E6FF;
                color: #409EFF !important;
                min-width: 1.72rem;
                &.van-tab--active {
                    min-width: 3.1rem;
                }
            }
            .van-tabs__line {
                // display: none;
            }
            .article{
                img{
                    max-width: 6.86rem;
                }
            }
            .column_box {
                padding-top: 0.8rem;
                padding-bottom: 0.32rem;
                .column_div {
                    padding: 0 0.32rem;
                    .no_data_box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 1rem 0;
                        img {
                            width: 1.9rem;
                            height: 1.8rem;
                        }
                        span {
                            color: #999999;
                            margin-top: 0.3rem;
                            font-size: 0.26rem;
                            line-height: 0.38rem;
                        }
                    }
                }
                .type1 {
                    padding-top: 0.32rem;
                    * {
                        max-width: 100%;
                        line-height: 0.38rem;
                        font-size: 0.28rem;
                    }
                }
                .type2 {
                    .video_box {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        &>div {
                            position: relative;
                            margin-top: 0.32rem;
                            .video_img {
                                background-color: rgba(0,0,0,0.4);
                                width: 3.28rem;
                                min-width: 3.28rem;
                                height: 1.82rem;
                                min-height: 1.82rem;
                                border-radius: 0.06rem;
                            }
                            .play_icon {
                                position: absolute;
                                top: 0;
                                left: 0;
                                bottom: 0;
                                right: 0;
                                margin: auto;
                                width: 0.5rem;
                                height: 0.5rem;
                            }
                        }
                    }
                }
                .type3 {
                    .imgs_box {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        img {
                            background-color: rgba(0,0,0,0.4);
                            margin-top: 0.32rem;
                            width: 3.28rem;
                            min-width: 3.28rem;
                            height: 1.82rem;
                            min-height: 1.82rem;
                            border-radius: 0.06rem;
                        }
                    }
                }
                .height100vh {
                    // box-sizing: border-box;
                    height: 100vh;
                    // overflow: scroll;
                }
                .type5 {
                    padding-bottom: 1rem;

                    box-sizing: border-box;
                    // height: 100vh;
                    overflow: scroll;
                    .discuss_warp {
                        .discuss_item_box {
                            margin-top: 0.32rem;
                            display: flex;
                            img {
                                width: 0.72rem;
                                min-width: 0.72rem;
                                height: 0.72rem;
                                min-height: 0.72rem;
                                margin-right: 0.16rem;
                                border-radius: 0.36rem;
                            }
                            .info_box {
                                .name_text {
                                    line-height: 0.38rem;
                                    font-size: 0.26rem;
                                    color: #999;
                                    margin-bottom: 0.08rem;
                                }
                                .is_me {
                                    color: #409EFF;
                                }
                                .msg_text {
                                    padding: 0.16rem 0.2rem;
                                    background-color: #F5F7FA;
                                    border-radius:0 0.2rem 0.2rem 0.2rem;
                                    line-height: 0.4rem;
                                    color: #333;
                                    font-size: 0.28rem;
                                    // text-align: justify;
                                }
                            }
                        }
                    }
                }
            }
            .label_box {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1001;
                color: #409EFF;
                height: 0.8rem;
                line-height: 0.8rem;
                font-size: 0.28rem;
                display: none;
            }
        }
        .buy_btn_box {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0.2rem 0.32rem;
            height: 1.2rem;
            box-sizing: border-box;
            background: #fff;
            z-index: 1000;
            .van-button {
                width: 100%;
                height: 0.8rem;
                background: #409EFF;
                border: none;
                border-radius: 0.4rem;
                color: #fff;
                .van-button__text {
                    font-size: 0.28rem;
                    .uprice {
                        font-size: 0.24rem;
                        margin-left: 0.2rem;
                        text-decoration: line-through;
                    }
                }
            }
        }
    }
    .videoShow_pop{
        // background: #67C23A;
        .van-popup{
            width: 100%;
            height: auto;
            video{
                width: 100%;
                display: block;
            }
        }
    }
    .bottom_warp {
        position: fixed;
        bottom: 0;
        width: 100vw;
        height: 1rem;
        background-color: #FFF;
        display: flex;
        align-items: center;
        justify-content: center;
        .logged {
            display: flex;
            .van-field {
                margin-right: 0.32rem;
                background-color: #F5F5F5;
                padding: 0;
                width: 5.3rem;
                height: 0.68rem;
                .van-field__body {
                    height: 0.68rem;
                    padding: 0 0.2rem;
                }
            }
            .van-button {
                height: 0.68rem;
                line-height: 0.68rem;
                box-sizing: border-box;
                background-color: #409EFF;
                border: 0.02rem solid #409EFF;
            }
        }
        .not_login {
            .van-button {
                width: 6.86rem;
                height: 0.68rem;
                line-height: 0.68rem;
                box-sizing: border-box;
                background-color: #409EFF;
                border: 0.02rem solid #409EFF;
            }
        }
    }
    .serviceqrurl_pop {
        .van-popup--center {
            width: 5.2rem;
            // height: 5.58rem;
            padding: 0.4rem 0;
            box-sizing: border-box;
            border-radius:0.15rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            &>img{
                width: 3.6rem;
                height: 3.6rem;
            }
            .nama_text {
                line-height:0.4rem;
                font-size:0.28rem;
                margin-bottom: 0.2rem;
            }
            .tip_text {
                font-size:0.26rem;
                line-height:0.4rem;
                margin-top: 0.2rem;
            }
        }
    }
    .input_password_pop {
        .van-popup {
            width: 6.4rem;
            height: 4.16rem;
            background: #fff;
            border-radius: 0.24rem;
            .title {
                padding: 0.64rem 0;
                text-align: center;
                font-size: 0.34rem;
                line-height: 0.48rem;
                font-weight: bold;
            }
            .input_box {
                padding: 0 0.48rem;
                margin-bottom: 0.64rem;
                .van-field {
                    width: 100%;
                    padding: 0 0 0.14rem;
                    border-bottom: 0.01rem solid rgba($color: #000000, $alpha: 0.1);
                    font-size: 0.34rem;
                }
            }
            .btn_box {
                border-top: 0.01rem solid rgba($color: #000000, $alpha: 0.1);
                height: 1.12rem;
                display: flex;
                align-items: stretch;
                box-sizing: border-box;
                div {
                    flex: 1;
                    text-align: center;
                    line-height: 1.12rem;
                    font-size: 0.34rem;
                    font-weight: bold;
                    box-sizing: border-box;
                }
                .affirm {
                    border-left: 0.01rem solid rgba($color: #000000, $alpha: 0.1);
                    color: #576B95;
                }
            }
        }
    }
    .shortcut_box {
        position: fixed;
        bottom: 1.48rem;
        right: 0.32rem;
        border-radius: 0.1rem;
        background:rgba(0,0,0,0.45);
        z-index: 1004;
        &>div {
            box-sizing: border-box;
            margin: 0 0.16rem;
            border-bottom: 0.01rem solid #FFF;
            width: 0.56rem;
            padding: 0.12rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #FFF;
            &>img {
                width: 0.4rem;
                height: 0.4rem;
                margin-bottom: 0.04rem;
            }
            &>span{
                font-size:0.18rem;
                line-height:0.25rem;
            }
        }
        &>div:nth-last-of-type(1){
            border-bottom: none;
        }
    }
}
.MliveDetails_warp {
    .vliveDetail{
        padding-top: 4.2rem;
        .content{
            .isFixed{
                .van-sticky{
                    top: 7.4rem;
                }
            }
        }
    }
    .live_msg_box {
        top: 4.22rem;
    }
}
</style>